__turbopack_context__.v({
  "Bottom": "HgZ-bW_Bottom",
  "Decoration": "HgZ-bW_Decoration",
  "None": "HgZ-bW_None",
  "Top": "HgZ-bW_Top",
  "curve": "HgZ-bW_curve",
  "root": "HgZ-bW_root",
});
